import { Col } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import TruckFilled from '../../../assets/icons/TruckFilled';
import { Cadencia, Card, CardRow, GrupoCadencia, Texto } from './styles';

const InfoCard = ({ showTagsContent, loading, label }) => (
  <Col key={label.title} xs={24} sm={12} md={8} lg={5} xl={3} className="mt-5">
    <Card>
      <Texto fontSize="14px" color="#74AA49">
        {label.title}
      </Texto>
      <CardRow>
        <GrupoCadencia>
          <Cadencia>{showTagsContent(loading, label)}</Cadencia>
          {label.showTruck && <TruckFilled size="16px" />}
        </GrupoCadencia>
        {label.texto && <Texto>{label.texto}</Texto>}
        {label.toneladas && (
          <Texto fontWeight="bold" fontSize="14px">
            {label.toneladas}
          </Texto>
        )}
      </CardRow>
    </Card>
  </Col>
);

InfoCard.propTypes = {
  showTagsContent: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  label: PropTypes.shape({
    title: PropTypes.string,
    texto: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    toneladas: PropTypes.string,
    showTruck: PropTypes.bool,
  }).isRequired,
};

export default InfoCard;
